import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { CommonProvider } from '../../providers/common/common';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'dateFormat',
})
export class DateFormatPipe implements PipeTransform {
  constructor(
    public datepipe: DatePipe,
    public comProv: CommonProvider,
    public translate: TranslateService,
  ){
  }

  transform(date:string, format:string) {        
    if (!date) {
      return;
    }
    let date_rep = date.replace(/-/g, '/');
    if (date_rep.indexOf('/') == -1 && date_rep.length == 8) {
      let yyyy = date_rep.substring(0, 4);
      let mm   = date_rep.substring(4, 6);
      let dd   = date_rep.substring(6, 8);
      date_rep = yyyy + '/' + mm + '/' + dd;
    }

    let date_for;

    let service_data = this.comProv.getService();
    if (service_data['option']['is_multilingual']) {
      let browser_lang = this.translate.getBrowserLang();
      if (browser_lang == 'en') {
        if (format.indexOf('##') == -1 ) {
          date_for = this.datepipe.transform(date_rep, 'mediumDate', '', browser_lang);
        } else {
          date_for = this.datepipe.transform(date_rep, 'E. MMM d, yyyy', '', browser_lang);
        }
        return date_for;
      }
    }

    // 曜日
    let weeks = ['日', '月', '火', '水', '木', '金', '土'];
    let date_obj = new Date(date_rep);
    let no = date_obj.getDay();
    let youbi = weeks[no];
    format = format.replace('##', youbi);

    date_for = this.datepipe.transform(date_rep, format);
    return date_for;
  }
}


// WEBPACK FOOTER //
// ./src/pipes/date-format/date-format.ts